/**
 * Live “This show” ticker: settled tips/charges plus unbilled coins-per-minute
 * accrued since the last totals snapshot.
 */
export function accrueShowEarnings(input: {
  settledCoins: number;
  settledEarningsCents: number;
  coinsPerMinute: number | null;
  billableViewerCount: number;
  extraSeconds: number;
  payoutRate: number;
}): { totalCoins: number; modelEarningsCents: number } {
  const rate = input.coinsPerMinute ?? 0;
  const billable = Math.max(0, input.billableViewerCount);
  const extraSeconds = Math.max(0, input.extraSeconds);
  if (rate <= 0 || billable <= 0 || extraSeconds <= 0) {
    return {
      totalCoins: input.settledCoins,
      modelEarningsCents: input.settledEarningsCents,
    };
  }

  const extraCoins = (rate * billable * extraSeconds) / 60;
  const extraCents = extraCoins * 10 * input.payoutRate;
  return {
    totalCoins: input.settledCoins + extraCoins,
    modelEarningsCents: Math.floor(input.settledEarningsCents + extraCents),
  };
}
